import axios from "axios";
import { API_REQUEST, apiError, apiSuccess, USER_API_REQUEST, userApiError, userApiSuccess } from "../actions/api";
import { setLoader } from "../actions/ui";

export const apiMiddleware = ({ dispatch }) => next => action => {
  next(action);

  if (action.type === API_REQUEST) {
    dispatch(setLoader(true));
    const { url, method, data, headers, auth } = action.meta;

    //console.log("method : ", method);
    //console.log("url : ", url);
    //console.log("headers : " + JSON.stringify(headers) + "\n");
    axios({
      method,
      url,
      data,
      headers,
      auth

    })
      .then(({ data }) => dispatch(apiSuccess({ response: data })))
      .catch(error => {
        console.log("core.js - Error  : ", error);
        dispatch(apiError({ error: error.response.status + " - " + error.response.statusText }));
      });
  } else if (action.type === USER_API_REQUEST) {
    dispatch(setLoader(true));
    const { url, method, data, headers, auth } = action.meta;

    //console.log("method : ", method);
    //console.log("url : ", url);
    // console.log("data : ", data);
    // console.log("auth : ", auth);
    console.log("headers : " + JSON.stringify(headers) + "\n");
    axios({
      method,
      url,
      data,
      headers,
      auth

    })
      .then(({ data }) => dispatch(userApiSuccess({ response: data })))
      .catch(error => {
        console.log("core.js - Error  : ", error);
        let resp = error.response.data;
        if (resp && (typeof resp !== 'undefined') && (Object.keys(resp).length !== 0)){
          if (resp.message.length> 0 && resp.message.length < 100) {
            dispatch(apiError({ error: resp.code + " - " + resp.status + ' : ' + resp.message }));
          } else {
            dispatch(apiError({ error: resp.status + " - " + resp.statusText }));
          }
        } else {
          dispatch(apiError({ error: resp.status + " - " + resp.statusText }));
        }
      });
  }
};
